export const translations = {
  pt: {
    // Navbar
    login: 'Login',
    startFree: 'Começar Grátis',
    history: 'Histórico',
    logout: 'Sair',
    dashboard: 'Dashboard',
    
    // Landing Page
    poweredByAI: 'Powered by AI',
    heroTitle: 'Análise de Apostas',
    heroTitleHighlight: 'Inteligência Artificial',
    heroSubtitle: 'Gere apostas múltiplas otimizadas com IA avançada. Escolha seu risco, defina suas odds e deixe a tecnologia criar o SharpSlip perfeito.',
    generateFirstSlip: 'Gerar Meu Primeiro Slip',
    alreadyHaveAccount: 'Já tenho conta',
    howItWorks: 'Como Funciona',
    advancedTech: 'Tecnologia de ponta para apostas inteligentes',
    
    feature1Title: 'Escolha Suas Preferências',
    feature1Desc: 'Defina odds alvo (2x, 3x, 4x, 5x) e nível de risco (Baixo, Médio, Alto). A IA adapta as seleções.',
    feature2Title: 'IA Gera SharpSlip',
    feature2Desc: 'Algoritmos analisam jogos e criam apostas múltiplas otimizadas com 2-4 eventos selecionados.',
    feature3Title: 'Análise Detalhada',
    feature3Desc: 'Receba probabilidades, score de confiança e explicação clara de cada seleção da IA.',
    
    readyToStart: 'Pronto para Começar?',
    ctaSubtitle: 'Crie sua conta gratuitamente e comece a gerar SharpSlips otimizados por IA agora mesmo.',
    startNow: 'Começar Agora',
    
    // Auth Pages
    welcomeBack: 'Bem-vindo de volta',
    enterAccount: 'Entre na sua conta para continuar',
    continueWithGoogle: 'Continuar com Google',
    or: 'ou',
    email: 'Email',
    password: 'Senha',
    enter: 'Entrar',
    noAccount: 'Não tem uma conta?',
    createAccount: 'Criar conta',
    
    createAccountTitle: 'Criar Conta',
    startGenerating: 'Comece a gerar SharpSlips agora',
    name: 'Nome',
    yourName: 'Seu nome',
    minChars: 'Mínimo 6 caracteres',
    creating: 'Criando...',
    create: 'Criar Conta',
    haveAccount: 'Já tem uma conta?',
    
    // Dashboard
    generateSharpSlipAI: 'Gerar SharpSlip com IA',
    targetOdds: 'Odds Alvo',
    riskLevel: 'Nível de Risco',
    low: 'Baixo',
    medium: 'Médio',
    high: 'Alto',
    generateSharpSlip: 'Gerar SharpSlip',
    generating: 'Gerando SharpSlip...',
    
    sharpSlipGenerated: 'SharpSlip Gerado',
    combinedOdds: 'Odds Combinadas',
    probability: 'Probabilidade',
    confidence: 'Confiança',
    selectedMatches: 'Jogos Selecionados',
    aiAnalysis: 'Análise da IA',
    
    todayMatches: 'Jogos de Hoje',
    home: 'Casa',
    draw: 'Empate',
    away: 'Fora',
    over: 'Over',
    under: 'Under',
    bothTeamsScore: 'Ambas Marcam',
    yes: 'Sim',
    no: 'Não',
    
    // History
    historyTitle: 'Histórico de SharpSlips',
    noSlipsYet: 'Nenhum SharpSlip gerado ainda',
    generateFirstSlipBtn: 'Gerar Primeiro Slip',
    targetOddsLabel: 'Odds Alvo',
    finalOdds: 'Odds Finais',
    
    // Toasts
    loginSuccess: 'Login realizado com sucesso!',
    accountCreated: 'Conta criada com sucesso!',
    slipGenerated: 'SharpSlip gerado com sucesso!',
    loginError: 'Erro ao fazer login',
    accountError: 'Erro ao criar conta',
    slipError: 'Erro ao gerar SharpSlip',
    loadMatchesError: 'Erro ao carregar jogos',
    loadHistoryError: 'Erro ao carregar histórico',
    
    // Date Range
    dateToday: 'Hoje',
    dateTomorrow: 'Amanhã',
    dateTodayTomorrow: 'Hoje + Amanhã',
    dateNext3Days: 'Próximos 3 Dias',
    dateCustom: 'Personalizado',
    matchPeriod: 'Período dos Jogos',
    noEligibleMatches: 'Sem jogos elegíveis para',
    tryOtherPeriod: 'Tenta outro período.',
    availableMatches: 'Jogos Disponíveis',
    
    // Navbar extras
    manage: 'Gerir',
    admin: 'Admin',
    upgrade: 'Upgrade',
    
    // Pricing Page
    choosePlan: 'Escolhe o Teu Plano',
    unlockAIBetting: 'Desbloqueia análise de apostas com IA e maximiza o teu potencial de vitória',
    backToDashboard: 'Voltar ao Dashboard',
    currentPlan: 'Plano Atual',
    freePlan: 'Plano Gratuito',
    upgradeToPro: 'Upgrade para Pro',
    upgradeToVip: 'Upgrade para VIP',
    lowerPlan: 'Plano Inferior',
    startWithBasics: 'Começa com o básico',
    bestValueBettors: 'Melhor valor para apostadores',
    ultimateBetting: 'Experiência de apostas definitiva',
    checkoutCanceled: 'Checkout cancelado. Podes tentar novamente quando quiseres.',
    alreadyPlan: 'Já és',
    downgradeContact: 'Para fazer downgrade, contacta o suporte.',
    checkoutFailed: 'Falha ao iniciar checkout. Tenta novamente.',
    bestValue: 'MELHOR VALOR',
    recommended: 'RECOMENDADO',
    
    // Plan Features
    oneSlip3Days: '1 SharpSlip a cada 3 dias',
    basicAnalysis: 'Análise básica de jogos',
    limitedAccess: 'Acesso limitado',
    unlimitedSlips: 'SharpSlips ilimitados',
    advancedInsights: 'Insights avançados de IA',
    valueBets: 'Detecção de value bets',
    fiveSlipsDay: '5 SharpSlips por dia',
    fullAnalysis: 'Análise completa de jogos',
    confidenceScore: 'Confidence Score detalhado',
    noAdsRestrictions: 'Sem anúncios ou restrições',
    basicAdvancedInsights: 'Insights avançados básicos',
    priorityPicks: 'Acesso prioritário a picks',
    unlimitedSlipsCaps: 'SharpSlips ILIMITADOS',
    mostAdvancedAI: 'Análise IA mais avançada',
    bestPicks: 'Melhores picks prioritários',
    allFeaturesUnlocked: 'Todas as features desbloqueadas',
    prioritySupport: 'Suporte prioritário',
    earlyAccess: 'Acesso antecipado a updates',
    perMonth: '/mês',
    
    // Admin Dashboard
    adminDashboard: 'Admin Dashboard',
    overview: 'Visão Geral',
    payments: 'Pagamentos',
    users: 'Utilizadores',
    analytics: 'Analytics',
    totalUsers: 'Total Utilizadores',
    onlineNow: 'Online Agora',
    totalRevenue: 'Receita Total',
    monthlyRevenue: 'Receita Mensal',
    planDistribution: 'Distribuição de Planos',
    subscriptionStatus: 'Estado de Subscrições',
    active: 'Ativas',
    canceled: 'Canceladas',
    expired: 'Expiradas',
    sharpslipsToday: 'SharpSlips Hoje',
    sharpslipsTotal: 'SharpSlips Total',
    allStates: 'Todos os estados',
    paid: 'Pago',
    pending: 'Pendente',
    failed: 'Falhou',
    email: 'Email',
    plan: 'Plano',
    amount: 'Valor',
    status: 'Estado',
    date: 'Data',
    noPayments: 'Sem pagamentos',
    searchEmailName: 'Pesquisar por email ou nome...',
    allPlans: 'Todos os planos',
    search: 'Pesquisar',
    user: 'Utilizador',
    sharpslips: 'SharpSlips',
    registration: 'Registo',
    lastLogin: 'Último Login',
    noUsers: 'Sem utilizadores',
    freeToProConversion: 'Free → Pro',
    proToVipConversion: 'Pro → VIP',
    conversionRate: 'Taxa de conversão',
    upgradeRate: 'Taxa de upgrade',
    mostActiveUsers: 'Utilizadores Mais Ativos',
    noActivityData: 'Sem dados de atividade',
    slipsPerDay: 'SharpSlips por Dia',
    signupsPerDay: 'Novos Registos por Dia',
    accessDenied: 'Acesso negado. Apenas admins podem aceder.',
    errorLoadingData: 'Erro ao carregar dados',
    congratsVip: 'Parabéns! Agora és VIP!',
    
    // Subscription Management
    manageSubscription: 'Gerir Subscrição',
    currentPlanLabel: 'Plano Atual',
    renewsOn: 'Renovação em',
    managePaymentBilling: 'Gerir Pagamento e Faturação',
    updatePaymentInfo: 'Atualizar método de pagamento, ver faturas ou cancelar',
    onFreePlan: 'Estás no plano Gratuito',
    viewPlans: 'Ver Planos',
    
    // Footer
    footerCopyright: '© 2026 SharpBetAI. Powered by Artificial Intelligence.',
    termsOfService: 'Termos de Serviço',
    privacyPolicy: 'Política de Privacidade',
    
    // Legal Pages
    termsTitle: 'Termos de Serviço',
    termsLastUpdate: 'Última atualização',
    privacyTitle: 'Política de Privacidade',
    
    // Betting Disclaimer
    disclaimerTitle: 'Aviso Legal - Apostas Desportivas',
    disclaimerAge: '18+ Apenas',
    disclaimerAgeText: 'Este serviço é estritamente para maiores de 18 anos. Ao utilizar o SharpBetAI, confirmas que tens idade legal para apostar na tua jurisdição.',
    disclaimerNoGuarantee: 'Sem Garantia de Lucro',
    disclaimerNoGuaranteeText: 'A IA analisa dados e fornece sugestões baseadas em estatísticas. Não garantimos lucros. Apostas envolvem risco de perda.',
    disclaimerResponsibility: 'Responsabilidade do Utilizador',
    disclaimerResponsibilityText: 'És totalmente responsável pelas tuas decisões de apostas. O SharpBetAI é uma ferramenta de análise, não aconselhamento financeiro.',
    disclaimerResponsibleGambling: 'Jogo Responsável',
    disclaimerResponsibleGamblingText: 'Aposta apenas o que podes perder. Se tiveres problemas com jogo, procura ajuda profissional.',
    disclaimerAccept: 'Li e Aceito',
    disclaimerDecline: 'Não Aceito',
    
    // Data Quality
    noRealMatchesAvailable: 'Sem jogos reais disponíveis de momento',
    onlyRealDataUsed: 'SharpSlips só podem ser gerados com dados verificados em tempo real. Tenta novamente mais tarde.',
    viewingDemoData: 'A visualizar dados de demonstração',
    
    // League Filter
    topLeaguesOnly: 'Apenas Ligas Top',
    allLeagues: 'Todas as Ligas',
    leagueFilter: 'Filtro de Ligas',
    topLeaguesDescription: 'Premier League, La Liga, Serie A, Bundesliga, Ligue 1, Champions League',
    qualityMatches: 'Jogos de qualidade',
    moreMatches: 'Mais jogos disponíveis',
    
    // Sport Mode
    sportMode: 'Modo Desporto',
    footballOnly: 'Futebol',
    tennisOnly: 'Ténis',
    autoMode: 'Auto',
    autoModeDesc: 'Futebol primeiro, depois Ténis',
    noQualityMatches: 'Sem oportunidades de apostas de alta qualidade disponíveis neste momento',
    eliteMatch: 'Liga Elite',
    professionalMatch: 'Liga Profissional',
    highConfidence: 'Alta Confiança',
    lowConfidence: 'Baixa Confiança',
    tennisSoon: 'Ténis em breve!'
  },
  
  en: {
    // Navbar
    login: 'Login',
    startFree: 'Start Free',
    history: 'History',
    logout: 'Logout',
    dashboard: 'Dashboard',
    
    // Landing Page
    poweredByAI: 'Powered by AI',
    heroTitle: 'Betting Analysis',
    heroTitleHighlight: 'Artificial Intelligence',
    heroSubtitle: 'Generate optimized multiple bets with advanced AI. Choose your risk, set your odds and let technology create the perfect SharpSlip.',
    generateFirstSlip: 'Generate My First Slip',
    alreadyHaveAccount: 'Already have an account',
    howItWorks: 'How It Works',
    advancedTech: 'Cutting-edge technology for smart betting',
    
    feature1Title: 'Choose Your Preferences',
    feature1Desc: 'Set target odds (2x, 3x, 4x, 5x) and risk level (Low, Medium, High). AI adapts selections.',
    feature2Title: 'AI Generates SharpSlip',
    feature2Desc: 'Algorithms analyze matches and create optimized multiple bets with 2-4 selected events.',
    feature3Title: 'Detailed Analysis',
    feature3Desc: 'Receive probabilities, confidence score and clear explanation of each AI selection.',
    
    readyToStart: 'Ready to Start?',
    ctaSubtitle: 'Create your free account and start generating AI-optimized SharpSlips right now.',
    startNow: 'Start Now',
    
    // Auth Pages
    welcomeBack: 'Welcome back',
    enterAccount: 'Sign in to your account to continue',
    continueWithGoogle: 'Continue with Google',
    or: 'or',
    email: 'Email',
    password: 'Password',
    enter: 'Sign In',
    noAccount: "Don't have an account?",
    createAccount: 'Create account',
    
    createAccountTitle: 'Create Account',
    startGenerating: 'Start generating SharpSlips now',
    name: 'Name',
    yourName: 'Your name',
    minChars: 'Minimum 6 characters',
    creating: 'Creating...',
    create: 'Create Account',
    haveAccount: 'Already have an account?',
    
    // Dashboard
    generateSharpSlipAI: 'Generate SharpSlip with AI',
    targetOdds: 'Target Odds',
    riskLevel: 'Risk Level',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    generateSharpSlip: 'Generate SharpSlip',
    generating: 'Generating SharpSlip...',
    
    sharpSlipGenerated: 'SharpSlip Generated',
    combinedOdds: 'Combined Odds',
    probability: 'Probability',
    confidence: 'Confidence',
    selectedMatches: 'Selected Matches',
    aiAnalysis: 'AI Analysis',
    
    todayMatches: "Today's Matches",
    home: 'Home',
    draw: 'Draw',
    away: 'Away',
    over: 'Over',
    under: 'Under',
    bothTeamsScore: 'Both Teams Score',
    yes: 'Yes',
    no: 'No',
    
    // History
    historyTitle: 'SharpSlips History',
    noSlipsYet: 'No SharpSlips generated yet',
    generateFirstSlipBtn: 'Generate First Slip',
    targetOddsLabel: 'Target Odds',
    finalOdds: 'Final Odds',
    
    // Toasts
    loginSuccess: 'Login successful!',
    accountCreated: 'Account created successfully!',
    slipGenerated: 'SharpSlip generated successfully!',
    loginError: 'Login error',
    accountError: 'Error creating account',
    slipError: 'Error generating SharpSlip',
    loadMatchesError: 'Error loading matches',
    loadHistoryError: 'Error loading history',
    
    // Date Range
    dateToday: 'Today',
    dateTomorrow: 'Tomorrow',
    dateTodayTomorrow: 'Today + Tomorrow',
    dateNext3Days: 'Next 3 Days',
    dateCustom: 'Custom',
    matchPeriod: 'Match Period',
    noEligibleMatches: 'No eligible matches for',
    tryOtherPeriod: 'Try another period.',
    availableMatches: 'Available Matches',
    
    // Navbar extras
    manage: 'Manage',
    admin: 'Admin',
    upgrade: 'Upgrade',
    
    // Pricing Page
    choosePlan: 'Choose Your Plan',
    unlockAIBetting: 'Unlock AI betting analysis and maximize your winning potential',
    backToDashboard: 'Back to Dashboard',
    currentPlan: 'Current Plan',
    freePlan: 'Free Plan',
    upgradeToPro: 'Upgrade to Pro',
    upgradeToVip: 'Upgrade to VIP',
    lowerPlan: 'Lower Plan',
    startWithBasics: 'Start with the basics',
    bestValueBettors: 'Best value for bettors',
    ultimateBetting: 'Ultimate betting experience',
    checkoutCanceled: 'Checkout canceled. You can try again whenever you want.',
    alreadyPlan: 'Already',
    downgradeContact: 'To downgrade, contact support.',
    checkoutFailed: 'Failed to start checkout. Try again.',
    bestValue: 'BEST VALUE',
    recommended: 'RECOMMENDED',
    
    // Plan Features
    oneSlip3Days: '1 SharpSlip every 3 days',
    basicAnalysis: 'Basic match analysis',
    limitedAccess: 'Limited access',
    unlimitedSlips: 'Unlimited SharpSlips',
    advancedInsights: 'Advanced AI insights',
    valueBets: 'Value bet detection',
    fiveSlipsDay: '5 SharpSlips per day',
    fullAnalysis: 'Full match analysis',
    confidenceScore: 'Detailed Confidence Score',
    noAdsRestrictions: 'No ads or restrictions',
    basicAdvancedInsights: 'Basic advanced insights',
    priorityPicks: 'Priority access to picks',
    unlimitedSlipsCaps: 'UNLIMITED SharpSlips',
    mostAdvancedAI: 'Most advanced AI analysis',
    bestPicks: 'Best priority picks',
    allFeaturesUnlocked: 'All features unlocked',
    prioritySupport: 'Priority support',
    earlyAccess: 'Early access to updates',
    perMonth: '/month',
    
    // Admin Dashboard
    adminDashboard: 'Admin Dashboard',
    overview: 'Overview',
    payments: 'Payments',
    users: 'Users',
    analytics: 'Analytics',
    totalUsers: 'Total Users',
    onlineNow: 'Online Now',
    totalRevenue: 'Total Revenue',
    monthlyRevenue: 'Monthly Revenue',
    planDistribution: 'Plan Distribution',
    subscriptionStatus: 'Subscription Status',
    active: 'Active',
    canceled: 'Canceled',
    expired: 'Expired',
    sharpslipsToday: 'SharpSlips Today',
    sharpslipsTotal: 'Total SharpSlips',
    allStates: 'All states',
    paid: 'Paid',
    pending: 'Pending',
    failed: 'Failed',
    email: 'Email',
    plan: 'Plan',
    amount: 'Amount',
    status: 'Status',
    date: 'Date',
    noPayments: 'No payments',
    searchEmailName: 'Search by email or name...',
    allPlans: 'All plans',
    search: 'Search',
    user: 'User',
    sharpslips: 'SharpSlips',
    registration: 'Registration',
    lastLogin: 'Last Login',
    noUsers: 'No users',
    freeToProConversion: 'Free → Pro',
    proToVipConversion: 'Pro → VIP',
    conversionRate: 'Conversion rate',
    upgradeRate: 'Upgrade rate',
    mostActiveUsers: 'Most Active Users',
    noActivityData: 'No activity data',
    slipsPerDay: 'SharpSlips per Day',
    signupsPerDay: 'New Signups per Day',
    accessDenied: 'Access denied. Only admins can access.',
    errorLoadingData: 'Error loading data',
    congratsVip: 'Congratulations! You are now VIP!',
    
    // Subscription Management
    manageSubscription: 'Manage Subscription',
    currentPlanLabel: 'Current Plan',
    renewsOn: 'Renews on',
    managePaymentBilling: 'Manage Payment & Billing',
    updatePaymentInfo: 'Update payment method, view invoices, or cancel',
    onFreePlan: 'You are on the Free plan',
    viewPlans: 'View Plans',
    
    // Footer
    footerCopyright: '© 2026 SharpBetAI. Powered by Artificial Intelligence.',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    
    // Legal Pages
    termsTitle: 'Terms of Service',
    termsLastUpdate: 'Last updated',
    privacyTitle: 'Privacy Policy',
    
    // Betting Disclaimer
    disclaimerTitle: 'Legal Notice - Sports Betting',
    disclaimerAge: '18+ Only',
    disclaimerAgeText: 'This service is strictly for users aged 18 and over. By using SharpBetAI, you confirm you are of legal age to place bets in your jurisdiction.',
    disclaimerNoGuarantee: 'No Profit Guarantee',
    disclaimerNoGuaranteeText: 'AI analyzes data and provides suggestions based on statistics. We do not guarantee profits. Betting involves risk of loss.',
    disclaimerResponsibility: 'User Responsibility',
    disclaimerResponsibilityText: 'You are fully responsible for your betting decisions. SharpBetAI is an analysis tool, not financial advice.',
    disclaimerResponsibleGambling: 'Responsible Gambling',
    disclaimerResponsibleGamblingText: 'Only bet what you can afford to lose. If you have gambling problems, seek professional help.',
    disclaimerAccept: 'I Read and Accept',
    disclaimerDecline: 'I Do Not Accept',
    
    // Data Quality
    noRealMatchesAvailable: 'No real matches available right now',
    onlyRealDataUsed: 'SharpSlips can only be generated with verified real-time data. Please try again later.',
    viewingDemoData: 'Viewing demo data',
    
    // League Filter
    topLeaguesOnly: 'Top Leagues Only',
    allLeagues: 'All Leagues',
    leagueFilter: 'League Filter',
    topLeaguesDescription: 'Premier League, La Liga, Serie A, Bundesliga, Ligue 1, Champions League',
    qualityMatches: 'Quality matches',
    moreMatches: 'More matches available',
    
    // Sport Mode
    sportMode: 'Sport Mode',
    footballOnly: 'Football',
    tennisOnly: 'Tennis',
    autoMode: 'Auto',
    autoModeDesc: 'Football first, then Tennis',
    noQualityMatches: 'No high-quality betting opportunities available right now',
    eliteMatch: 'Elite League',
    professionalMatch: 'Professional League',
    highConfidence: 'High Confidence',
    lowConfidence: 'Low Confidence',
    tennisSoon: 'Tennis coming soon!'
  },
  
  es: {
    // Navbar
    login: 'Iniciar sesión',
    startFree: 'Comenzar Gratis',
    history: 'Historial',
    logout: 'Salir',
    dashboard: 'Panel',
    
    // Landing Page
    poweredByAI: 'Powered by AI',
    heroTitle: 'Análisis de Apuestas',
    heroTitleHighlight: 'Inteligencia Artificial',
    heroSubtitle: 'Genera apuestas múltiples optimizadas con IA avanzada. Elige tu riesgo, define tus cuotas y deja que la tecnología cree el SharpSlip perfecto.',
    generateFirstSlip: 'Generar Mi Primer Slip',
    alreadyHaveAccount: 'Ya tengo cuenta',
    howItWorks: 'Cómo Funciona',
    advancedTech: 'Tecnología de vanguardia para apuestas inteligentes',
    
    feature1Title: 'Elige Tus Preferencias',
    feature1Desc: 'Define cuotas objetivo (2x, 3x, 4x, 5x) y nivel de riesgo (Bajo, Medio, Alto). La IA adapta las selecciones.',
    feature2Title: 'IA Genera SharpSlip',
    feature2Desc: 'Los algoritmos analizan partidos y crean apuestas múltiples optimizadas con 2-4 eventos seleccionados.',
    feature3Title: 'Análisis Detallado',
    feature3Desc: 'Recibe probabilidades, puntuación de confianza y explicación clara de cada selección de IA.',
    
    readyToStart: '¿Listo para Comenzar?',
    ctaSubtitle: 'Crea tu cuenta gratis y comienza a generar SharpSlips optimizados por IA ahora mismo.',
    startNow: 'Comenzar Ahora',
    
    // Auth Pages
    welcomeBack: 'Bienvenido de nuevo',
    enterAccount: 'Inicia sesión en tu cuenta para continuar',
    continueWithGoogle: 'Continuar con Google',
    or: 'o',
    email: 'Correo',
    password: 'Contraseña',
    enter: 'Entrar',
    noAccount: '¿No tienes cuenta?',
    createAccount: 'Crear cuenta',
    
    createAccountTitle: 'Crear Cuenta',
    startGenerating: 'Comienza a generar SharpSlips ahora',
    name: 'Nombre',
    yourName: 'Tu nombre',
    minChars: 'Mínimo 6 caracteres',
    creating: 'Creando...',
    create: 'Crear Cuenta',
    haveAccount: '¿Ya tienes cuenta?',
    
    // Dashboard
    generateSharpSlipAI: 'Generar SharpSlip con IA',
    targetOdds: 'Cuotas Objetivo',
    riskLevel: 'Nivel de Riesgo',
    low: 'Bajo',
    medium: 'Medio',
    high: 'Alto',
    generateSharpSlip: 'Generar SharpSlip',
    generating: 'Generando SharpSlip...',
    
    sharpSlipGenerated: 'SharpSlip Generado',
    combinedOdds: 'Cuotas Combinadas',
    probability: 'Probabilidad',
    confidence: 'Confianza',
    selectedMatches: 'Partidos Seleccionados',
    aiAnalysis: 'Análisis IA',
    
    todayMatches: 'Partidos de Hoy',
    home: 'Local',
    draw: 'Empate',
    away: 'Visitante',
    over: 'Más',
    under: 'Menos',
    bothTeamsScore: 'Ambos Marcan',
    yes: 'Sí',
    no: 'No',
    
    // History
    historyTitle: 'Historial de SharpSlips',
    noSlipsYet: 'Ningún SharpSlip generado aún',
    generateFirstSlipBtn: 'Generar Primer Slip',
    targetOddsLabel: 'Cuotas Objetivo',
    finalOdds: 'Cuotas Finales',
    
    // Toasts
    loginSuccess: '¡Inicio de sesión exitoso!',
    accountCreated: '¡Cuenta creada con éxito!',
    slipGenerated: '¡SharpSlip generado con éxito!',
    loginError: 'Error al iniciar sesión',
    accountError: 'Error al crear cuenta',
    slipError: 'Error al generar SharpSlip',
    loadMatchesError: 'Error al cargar partidos',
    loadHistoryError: 'Error al cargar historial',
    
    // Date Range
    dateToday: 'Hoy',
    dateTomorrow: 'Mañana',
    dateTodayTomorrow: 'Hoy + Mañana',
    dateNext3Days: 'Próximos 3 Días',
    dateCustom: 'Personalizado',
    matchPeriod: 'Período de Partidos',
    noEligibleMatches: 'Sin partidos elegibles para',
    tryOtherPeriod: 'Intenta otro período.',
    availableMatches: 'Partidos Disponibles',
    
    // Navbar extras
    manage: 'Gestionar',
    admin: 'Admin',
    upgrade: 'Mejorar',
    
    // Pricing Page
    choosePlan: 'Elige Tu Plan',
    unlockAIBetting: 'Desbloquea análisis de apuestas con IA y maximiza tu potencial de victoria',
    backToDashboard: 'Volver al Panel',
    currentPlan: 'Plan Actual',
    freePlan: 'Plan Gratuito',
    upgradeToPro: 'Mejorar a Pro',
    upgradeToVip: 'Mejorar a VIP',
    lowerPlan: 'Plan Inferior',
    startWithBasics: 'Comienza con lo básico',
    bestValueBettors: 'Mejor valor para apostadores',
    ultimateBetting: 'Experiencia de apuestas definitiva',
    checkoutCanceled: 'Checkout cancelado. Puedes intentar de nuevo cuando quieras.',
    alreadyPlan: 'Ya eres',
    downgradeContact: 'Para bajar de plan, contacta al soporte.',
    checkoutFailed: 'Fallo al iniciar checkout. Intenta de nuevo.',
    bestValue: 'MEJOR VALOR',
    recommended: 'RECOMENDADO',
    
    // Plan Features
    oneSlip3Days: '1 SharpSlip cada 3 días',
    basicAnalysis: 'Análisis básico de partidos',
    limitedAccess: 'Acceso limitado',
    unlimitedSlips: 'SharpSlips ilimitados',
    advancedInsights: 'Insights avanzados de IA',
    valueBets: 'Detección de value bets',
    fiveSlipsDay: '5 SharpSlips por día',
    fullAnalysis: 'Análisis completo de partidos',
    confidenceScore: 'Confidence Score detallado',
    noAdsRestrictions: 'Sin anuncios o restricciones',
    basicAdvancedInsights: 'Insights avanzados básicos',
    priorityPicks: 'Acceso prioritario a picks',
    unlimitedSlipsCaps: 'SharpSlips ILIMITADOS',
    mostAdvancedAI: 'Análisis IA más avanzada',
    bestPicks: 'Mejores picks prioritarios',
    allFeaturesUnlocked: 'Todas las features desbloqueadas',
    prioritySupport: 'Soporte prioritario',
    earlyAccess: 'Acceso anticipado a updates',
    perMonth: '/mes',
    
    // Admin Dashboard
    adminDashboard: 'Panel de Admin',
    overview: 'Visión General',
    payments: 'Pagos',
    users: 'Usuarios',
    analytics: 'Analíticas',
    totalUsers: 'Total Usuarios',
    onlineNow: 'En Línea Ahora',
    totalRevenue: 'Ingresos Totales',
    monthlyRevenue: 'Ingresos Mensuales',
    planDistribution: 'Distribución de Planes',
    subscriptionStatus: 'Estado de Suscripciones',
    active: 'Activas',
    canceled: 'Canceladas',
    expired: 'Expiradas',
    sharpslipsToday: 'SharpSlips Hoy',
    sharpslipsTotal: 'SharpSlips Total',
    allStates: 'Todos los estados',
    paid: 'Pagado',
    pending: 'Pendiente',
    failed: 'Fallido',
    email: 'Correo',
    plan: 'Plan',
    amount: 'Monto',
    status: 'Estado',
    date: 'Fecha',
    noPayments: 'Sin pagos',
    searchEmailName: 'Buscar por correo o nombre...',
    allPlans: 'Todos los planes',
    search: 'Buscar',
    user: 'Usuario',
    sharpslips: 'SharpSlips',
    registration: 'Registro',
    lastLogin: 'Último Login',
    noUsers: 'Sin usuarios',
    freeToProConversion: 'Free → Pro',
    proToVipConversion: 'Pro → VIP',
    conversionRate: 'Tasa de conversión',
    upgradeRate: 'Tasa de mejora',
    mostActiveUsers: 'Usuarios Más Activos',
    noActivityData: 'Sin datos de actividad',
    slipsPerDay: 'SharpSlips por Día',
    signupsPerDay: 'Nuevos Registros por Día',
    accessDenied: 'Acceso denegado. Solo admins pueden acceder.',
    errorLoadingData: 'Error al cargar datos',
    congratsVip: '¡Felicidades! Ahora eres VIP!',
    
    // Subscription Management
    manageSubscription: 'Gestionar Suscripción',
    currentPlanLabel: 'Plan Actual',
    renewsOn: 'Renovación el',
    managePaymentBilling: 'Gestionar Pago y Facturación',
    updatePaymentInfo: 'Actualizar método de pago, ver facturas o cancelar',
    onFreePlan: 'Estás en el plan Gratuito',
    viewPlans: 'Ver Planes',
    
    // Footer
    footerCopyright: '© 2026 SharpBetAI. Powered by Artificial Intelligence.',
    
    // League Filter
    topLeaguesOnly: 'Solo Ligas Top',
    allLeagues: 'Todas las Ligas',
    leagueFilter: 'Filtro de Ligas',
    topLeaguesDescription: 'Premier League, La Liga, Serie A, Bundesliga, Ligue 1, Champions League',
    qualityMatches: 'Partidos de calidad',
    moreMatches: 'Más partidos disponibles',
    
    // Sport Mode
    sportMode: 'Modo Deporte',
    footballOnly: 'Fútbol',
    tennisOnly: 'Tenis',
    autoMode: 'Auto',
    autoModeDesc: 'Fútbol primero, luego Tenis',
    noQualityMatches: 'No hay oportunidades de apuestas de alta calidad disponibles en este momento',
    eliteMatch: 'Liga Elite',
    professionalMatch: 'Liga Profesional',
    highConfidence: 'Alta Confianza',
    lowConfidence: 'Baja Confianza',
    tennisSoon: '¡Tenis próximamente!'
  },
  
  fr: {
    // Navbar
    login: 'Connexion',
    startFree: 'Commencer Gratuit',
    history: 'Historique',
    logout: 'Déconnexion',
    dashboard: 'Tableau de bord',
    
    // Landing Page
    poweredByAI: 'Powered by AI',
    heroTitle: 'Analyse de Paris',
    heroTitleHighlight: 'Intelligence Artificielle',
    heroSubtitle: 'Générez des paris multiples optimisés avec une IA avancée. Choisissez votre risque, définissez vos cotes et laissez la technologie créer le SharpSlip parfait.',
    generateFirstSlip: 'Générer Mon Premier Slip',
    alreadyHaveAccount: "J'ai déjà un compte",
    howItWorks: 'Comment Ça Marche',
    advancedTech: 'Technologie de pointe pour paris intelligents',
    
    feature1Title: 'Choisissez Vos Préférences',
    feature1Desc: 'Définissez les cotes cibles (2x, 3x, 4x, 5x) et le niveau de risque (Faible, Moyen, Élevé). L\'IA adapte les sélections.',
    feature2Title: 'L\'IA Génère SharpSlip',
    feature2Desc: 'Les algorithmes analysent les matchs et créent des paris multiples optimisés avec 2 à 4 événements sélectionnés.',
    feature3Title: 'Analyse Détaillée',
    feature3Desc: 'Recevez des probabilités, un score de confiance et une explication claire de chaque sélection IA.',
    
    readyToStart: 'Prêt à Commencer?',
    ctaSubtitle: 'Créez votre compte gratuit et commencez à générer des SharpSlips optimisés par IA dès maintenant.',
    startNow: 'Commencer Maintenant',
    
    // Auth Pages
    welcomeBack: 'Bon retour',
    enterAccount: 'Connectez-vous à votre compte pour continuer',
    continueWithGoogle: 'Continuer avec Google',
    or: 'ou',
    email: 'Email',
    password: 'Mot de passe',
    enter: 'Se connecter',
    noAccount: "Pas de compte?",
    createAccount: 'Créer un compte',
    
    createAccountTitle: 'Créer un Compte',
    startGenerating: 'Commencez à générer des SharpSlips maintenant',
    name: 'Nom',
    yourName: 'Votre nom',
    minChars: 'Minimum 6 caractères',
    creating: 'Création...',
    create: 'Créer un Compte',
    haveAccount: 'Vous avez déjà un compte?',
    
    // Dashboard
    generateSharpSlipAI: 'Générer SharpSlip avec IA',
    targetOdds: 'Cotes Cibles',
    riskLevel: 'Niveau de Risque',
    low: 'Faible',
    medium: 'Moyen',
    high: 'Élevé',
    generateSharpSlip: 'Générer SharpSlip',
    generating: 'Génération SharpSlip...',
    
    sharpSlipGenerated: 'SharpSlip Généré',
    combinedOdds: 'Cotes Combinées',
    probability: 'Probabilité',
    confidence: 'Confiance',
    selectedMatches: 'Matchs Sélectionnés',
    aiAnalysis: 'Analyse IA',
    
    todayMatches: "Matchs d'Aujourd'hui",
    home: 'Domicile',
    draw: 'Nul',
    away: 'Extérieur',
    over: 'Plus',
    under: 'Moins',
    bothTeamsScore: 'Les Deux Marquent',
    yes: 'Oui',
    no: 'Non',
    
    // History
    historyTitle: 'Historique des SharpSlips',
    noSlipsYet: 'Aucun SharpSlip généré pour le moment',
    generateFirstSlipBtn: 'Générer le Premier Slip',
    targetOddsLabel: 'Cotes Cibles',
    finalOdds: 'Cotes Finales',
    
    // Toasts
    loginSuccess: 'Connexion réussie!',
    accountCreated: 'Compte créé avec succès!',
    slipGenerated: 'SharpSlip généré avec succès!',
    loginError: 'Erreur de connexion',
    accountError: 'Erreur lors de la création du compte',
    slipError: 'Erreur lors de la génération du SharpSlip',
    loadMatchesError: 'Erreur lors du chargement des matchs',
    loadHistoryError: "Erreur lors du chargement de l'historique",
    
    // Date Range
    dateToday: "Aujourd'hui",
    dateTomorrow: 'Demain',
    dateTodayTomorrow: "Aujourd'hui + Demain",
    dateNext3Days: '3 Prochains Jours',
    dateCustom: 'Personnalisé',
    matchPeriod: 'Période des Matchs',
    noEligibleMatches: 'Pas de matchs éligibles pour',
    tryOtherPeriod: 'Essayez une autre période.',
    availableMatches: 'Matchs Disponibles',
    
    // Navbar extras
    manage: 'Gérer',
    admin: 'Admin',
    upgrade: 'Améliorer',
    
    // Pricing Page
    choosePlan: 'Choisissez Votre Plan',
    unlockAIBetting: "Débloquez l'analyse de paris IA et maximisez votre potentiel de gains",
    backToDashboard: 'Retour au Tableau de bord',
    currentPlan: 'Plan Actuel',
    freePlan: 'Plan Gratuit',
    upgradeToPro: 'Passer à Pro',
    upgradeToVip: 'Passer à VIP',
    lowerPlan: 'Plan Inférieur',
    startWithBasics: 'Commencez avec les bases',
    bestValueBettors: 'Meilleur rapport qualité-prix pour les parieurs',
    ultimateBetting: 'Expérience de paris ultime',
    checkoutCanceled: 'Paiement annulé. Vous pouvez réessayer quand vous voulez.',
    alreadyPlan: 'Déjà',
    downgradeContact: 'Pour rétrograder, contactez le support.',
    checkoutFailed: 'Échec du paiement. Réessayez.',
    bestValue: 'MEILLEUR RAPPORT',
    recommended: 'RECOMMANDÉ',
    
    // Plan Features
    oneSlip3Days: '1 SharpSlip tous les 3 jours',
    basicAnalysis: 'Analyse de base des matchs',
    limitedAccess: 'Accès limité',
    unlimitedSlips: 'SharpSlips illimités',
    advancedInsights: "Insights IA avancés",
    valueBets: 'Détection des value bets',
    fiveSlipsDay: '5 SharpSlips par jour',
    fullAnalysis: 'Analyse complète des matchs',
    confidenceScore: 'Score de Confiance détaillé',
    noAdsRestrictions: 'Sans publicités ni restrictions',
    basicAdvancedInsights: 'Insights avancés de base',
    priorityPicks: 'Accès prioritaire aux picks',
    unlimitedSlipsCaps: 'SharpSlips ILLIMITÉS',
    mostAdvancedAI: 'Analyse IA la plus avancée',
    bestPicks: 'Meilleurs picks prioritaires',
    allFeaturesUnlocked: 'Toutes les fonctionnalités débloquées',
    prioritySupport: 'Support prioritaire',
    earlyAccess: 'Accès anticipé aux mises à jour',
    perMonth: '/mois',
    
    // Admin Dashboard
    adminDashboard: 'Tableau de bord Admin',
    overview: 'Vue Générale',
    payments: 'Paiements',
    users: 'Utilisateurs',
    analytics: 'Analytiques',
    totalUsers: 'Total Utilisateurs',
    onlineNow: 'En Ligne Maintenant',
    totalRevenue: 'Revenu Total',
    monthlyRevenue: 'Revenu Mensuel',
    planDistribution: 'Distribution des Plans',
    subscriptionStatus: 'Statut Abonnement',
    active: 'Actif',
    canceled: 'Annulé',
    expired: 'Expiré',
    sharpslipsToday: "SharpSlips Aujourd'hui",
    sharpslipsTotal: 'SharpSlips Total',
    allStates: 'Tous les états',
    paid: 'Payé',
    pending: 'En attente',
    failed: 'Échoué',
    plan: 'Plan',
    amount: 'Montant',
    status: 'Statut',
    date: 'Date',
    noPayments: 'Aucun paiement',
    searchEmailName: 'Rechercher par email ou nom...',
    allPlans: 'Tous les plans',
    search: 'Rechercher',
    user: 'Utilisateur',
    sharpslips: 'SharpSlips',
    registration: 'Inscription',
    lastLogin: 'Dernière Connexion',
    noUsers: 'Aucun utilisateur',
    freeToProConversion: 'Free → Pro',
    proToVipConversion: 'Pro → VIP',
    conversionRate: 'Taux de conversion',
    upgradeRate: "Taux d'amélioration",
    mostActiveUsers: 'Utilisateurs Les Plus Actifs',
    noActivityData: "Pas de données d'activité",
    slipsPerDay: 'SharpSlips par Jour',
    signupsPerDay: 'Nouvelles Inscriptions par Jour',
    accessDenied: 'Accès refusé. Seuls les admins peuvent accéder.',
    errorLoadingData: 'Erreur de chargement des données',
    congratsVip: 'Félicitations! Vous êtes maintenant VIP!',
    
    // Subscription Management
    manageSubscription: "Gérer l'Abonnement",
    currentPlanLabel: 'Plan Actuel',
    renewsOn: 'Renouvellement le',
    managePaymentBilling: 'Gérer Paiement et Facturation',
    updatePaymentInfo: 'Mettre à jour le mode de paiement, voir les factures ou annuler',
    onFreePlan: 'Vous êtes sur le plan Gratuit',
    viewPlans: 'Voir les Plans',
    
    // Footer
    footerCopyright: '© 2026 SharpBetAI. Powered by Artificial Intelligence.',
    
    // League Filter
    topLeaguesOnly: 'Ligues Top Uniquement',
    allLeagues: 'Toutes les Ligues',
    leagueFilter: 'Filtre de Ligues',
    topLeaguesDescription: 'Premier League, La Liga, Serie A, Bundesliga, Ligue 1, Champions League',
    qualityMatches: 'Matchs de qualité',
    moreMatches: 'Plus de matchs disponibles',
    
    // Sport Mode
    sportMode: 'Mode Sport',
    footballOnly: 'Football',
    tennisOnly: 'Tennis',
    autoMode: 'Auto',
    autoModeDesc: 'Football d\'abord, puis Tennis',
    noQualityMatches: 'Aucune opportunité de pari de haute qualité disponible pour le moment',
    eliteMatch: 'Ligue Elite',
    professionalMatch: 'Ligue Professionnelle',
    highConfidence: 'Haute Confiance',
    lowConfidence: 'Basse Confiance',
    tennisSoon: 'Tennis bientôt disponible!'
  },
  
  de: {
    // Navbar
    login: 'Anmelden',
    startFree: 'Kostenlos Starten',
    history: 'Verlauf',
    logout: 'Abmelden',
    dashboard: 'Dashboard',
    
    // Landing Page
    poweredByAI: 'Powered by AI',
    heroTitle: 'Wettanalyse',
    heroTitleHighlight: 'Künstliche Intelligenz',
    heroSubtitle: 'Generieren Sie optimierte Kombiwetten mit fortschrittlicher KI. Wählen Sie Ihr Risiko, definieren Sie Ihre Quoten und lassen Sie die Technologie den perfekten SharpSlip erstellen.',
    generateFirstSlip: 'Meinen Ersten Slip Generieren',
    alreadyHaveAccount: 'Ich habe bereits ein Konto',
    howItWorks: 'So Funktioniert Es',
    advancedTech: 'Spitzentechnologie für intelligente Wetten',
    
    feature1Title: 'Wählen Sie Ihre Präferenzen',
    feature1Desc: 'Definieren Sie Zielquoten (2x, 3x, 4x, 5x) und Risikoniveau (Niedrig, Mittel, Hoch). Die KI passt die Auswahl an.',
    feature2Title: 'KI Generiert SharpSlip',
    feature2Desc: 'Algorithmen analysieren Spiele und erstellen optimierte Kombiwetten mit 2-4 ausgewählten Events.',
    feature3Title: 'Detaillierte Analyse',
    feature3Desc: 'Erhalten Sie Wahrscheinlichkeiten, Konfidenzwerte und eine klare Erklärung jeder KI-Auswahl.',
    
    readyToStart: 'Bereit zu Starten?',
    ctaSubtitle: 'Erstellen Sie Ihr kostenloses Konto und beginnen Sie jetzt, KI-optimierte SharpSlips zu generieren.',
    startNow: 'Jetzt Starten',
    
    // Auth Pages
    welcomeBack: 'Willkommen Zurück',
    enterAccount: 'Melden Sie sich an, um fortzufahren',
    continueWithGoogle: 'Mit Google Fortfahren',
    or: 'oder',
    email: 'E-Mail',
    password: 'Passwort',
    enter: 'Anmelden',
    noAccount: 'Kein Konto?',
    createAccount: 'Konto Erstellen',
    
    createAccountTitle: 'Konto Erstellen',
    startGenerating: 'Beginnen Sie jetzt mit der Generierung von SharpSlips',
    name: 'Name',
    yourName: 'Ihr Name',
    minChars: 'Mindestens 6 Zeichen',
    creating: 'Wird erstellt...',
    create: 'Konto Erstellen',
    haveAccount: 'Haben Sie bereits ein Konto?',
    
    // Dashboard
    generateSharpSlipAI: 'SharpSlip mit KI Generieren',
    targetOdds: 'Zielquoten',
    riskLevel: 'Risikoniveau',
    low: 'Niedrig',
    medium: 'Mittel',
    high: 'Hoch',
    generateSharpSlip: 'SharpSlip Generieren',
    generating: 'SharpSlip wird generiert...',
    
    sharpSlipGenerated: 'SharpSlip Generiert',
    combinedOdds: 'Kombinierte Quoten',
    probability: 'Wahrscheinlichkeit',
    confidence: 'Konfidenz',
    selectedMatches: 'Ausgewählte Spiele',
    aiAnalysis: 'KI-Analyse',
    
    todayMatches: 'Heutige Spiele',
    home: 'Heim',
    draw: 'Unentschieden',
    away: 'Auswärts',
    over: 'Über',
    under: 'Unter',
    bothTeamsScore: 'Beide Teams Treffen',
    yes: 'Ja',
    no: 'Nein',
    
    // History
    historyTitle: 'SharpSlip Verlauf',
    noSlipsYet: 'Noch kein SharpSlip generiert',
    generateFirstSlipBtn: 'Ersten Slip Generieren',
    targetOddsLabel: 'Zielquoten',
    finalOdds: 'Endquoten',
    
    // Toasts
    loginSuccess: 'Anmeldung erfolgreich!',
    accountCreated: 'Konto erfolgreich erstellt!',
    slipGenerated: 'SharpSlip erfolgreich generiert!',
    loginError: 'Anmeldefehler',
    accountError: 'Fehler beim Erstellen des Kontos',
    slipError: 'Fehler beim Generieren des SharpSlips',
    loadMatchesError: 'Fehler beim Laden der Spiele',
    loadHistoryError: 'Fehler beim Laden des Verlaufs',
    
    // Date Range
    dateToday: 'Heute',
    dateTomorrow: 'Morgen',
    dateTodayTomorrow: 'Heute + Morgen',
    dateNext3Days: 'Nächste 3 Tage',
    dateCustom: 'Benutzerdefiniert',
    matchPeriod: 'Spielzeitraum',
    noEligibleMatches: 'Keine geeigneten Spiele für',
    tryOtherPeriod: 'Versuchen Sie einen anderen Zeitraum.',
    availableMatches: 'Verfügbare Spiele',
    
    // Navbar extras
    manage: 'Verwalten',
    admin: 'Admin',
    upgrade: 'Upgrade',
    
    // Pricing Page
    choosePlan: 'Wählen Sie Ihren Plan',
    unlockAIBetting: 'Schalten Sie KI-Wettanalyse frei und maximieren Sie Ihr Gewinnpotenzial',
    backToDashboard: 'Zurück zum Dashboard',
    currentPlan: 'Aktueller Plan',
    freePlan: 'Kostenloser Plan',
    upgradeToPro: 'Auf Pro Upgraden',
    upgradeToVip: 'Auf VIP Upgraden',
    lowerPlan: 'Niedrigerer Plan',
    startWithBasics: 'Beginnen Sie mit den Grundlagen',
    bestValueBettors: 'Bestes Preis-Leistungs-Verhältnis für Wetter',
    ultimateBetting: 'Das ultimative Wetterlebnis',
    checkoutCanceled: 'Checkout abgebrochen. Sie können es jederzeit erneut versuchen.',
    alreadyPlan: 'Bereits',
    downgradeContact: 'Zum Herabstufen kontaktieren Sie den Support.',
    checkoutFailed: 'Checkout fehlgeschlagen. Versuchen Sie es erneut.',
    bestValue: 'BESTER WERT',
    recommended: 'EMPFOHLEN',
    
    // Plan Features
    oneSlip3Days: '1 SharpSlip alle 3 Tage',
    basicAnalysis: 'Grundlegende Spielanalyse',
    limitedAccess: 'Eingeschränkter Zugang',
    unlimitedSlips: 'Unbegrenzte SharpSlips',
    advancedInsights: 'Erweiterte KI-Einblicke',
    valueBets: 'Value-Bet-Erkennung',
    fiveSlipsDay: '5 SharpSlips pro Tag',
    fullAnalysis: 'Vollständige Spielanalyse',
    confidenceScore: 'Detaillierter Konfidenzwert',
    noAdsRestrictions: 'Keine Werbung oder Einschränkungen',
    basicAdvancedInsights: 'Grundlegende erweiterte Einblicke',
    priorityPicks: 'Prioritätszugang zu Picks',
    unlimitedSlipsCaps: 'UNBEGRENZTE SharpSlips',
    mostAdvancedAI: 'Fortschrittlichste KI-Analyse',
    bestPicks: 'Beste Prioritäts-Picks',
    allFeaturesUnlocked: 'Alle Funktionen freigeschaltet',
    prioritySupport: 'Prioritäts-Support',
    earlyAccess: 'Frühzeitiger Zugang zu Updates',
    perMonth: '/Monat',
    
    // Admin Dashboard
    adminDashboard: 'Admin Dashboard',
    overview: 'Übersicht',
    payments: 'Zahlungen',
    users: 'Benutzer',
    analytics: 'Analytik',
    totalUsers: 'Benutzer Gesamt',
    onlineNow: 'Jetzt Online',
    totalRevenue: 'Gesamtumsatz',
    monthlyRevenue: 'Monatlicher Umsatz',
    planDistribution: 'Planverteilung',
    subscriptionStatus: 'Abonnement-Status',
    active: 'Aktiv',
    canceled: 'Gekündigt',
    expired: 'Abgelaufen',
    sharpslipsToday: 'SharpSlips Heute',
    sharpslipsTotal: 'SharpSlips Gesamt',
    allStates: 'Alle Status',
    paid: 'Bezahlt',
    pending: 'Ausstehend',
    failed: 'Fehlgeschlagen',
    plan: 'Plan',
    amount: 'Betrag',
    status: 'Status',
    date: 'Datum',
    noPayments: 'Keine Zahlungen',
    searchEmailName: 'Nach E-Mail oder Name suchen...',
    allPlans: 'Alle Pläne',
    search: 'Suchen',
    user: 'Benutzer',
    sharpslips: 'SharpSlips',
    registration: 'Registrierung',
    lastLogin: 'Letzte Anmeldung',
    noUsers: 'Keine Benutzer',
    freeToProConversion: 'Free → Pro',
    proToVipConversion: 'Pro → VIP',
    conversionRate: 'Konversionsrate',
    upgradeRate: 'Upgrade-Rate',
    mostActiveUsers: 'Aktivste Benutzer',
    noActivityData: 'Keine Aktivitätsdaten',
    slipsPerDay: 'SharpSlips pro Tag',
    signupsPerDay: 'Neue Anmeldungen pro Tag',
    accessDenied: 'Zugriff verweigert. Nur Admins haben Zugriff.',
    errorLoadingData: 'Fehler beim Laden der Daten',
    congratsVip: 'Herzlichen Glückwunsch! Sie sind jetzt VIP!',
    
    // Subscription Management
    manageSubscription: 'Abonnement Verwalten',
    currentPlanLabel: 'Aktueller Plan',
    renewsOn: 'Verlängerung am',
    managePaymentBilling: 'Zahlung & Abrechnung Verwalten',
    updatePaymentInfo: 'Zahlungsmethode aktualisieren, Rechnungen einsehen oder kündigen',
    onFreePlan: 'Sie sind im kostenlosen Plan',
    viewPlans: 'Pläne Ansehen',
    
    // Footer
    footerCopyright: '© 2026 SharpBetAI. Powered by Artificial Intelligence.',
    
    // League Filter
    topLeaguesOnly: 'Nur Top-Ligen',
    allLeagues: 'Alle Ligen',
    leagueFilter: 'Liga-Filter',
    topLeaguesDescription: 'Premier League, La Liga, Serie A, Bundesliga, Ligue 1, Champions League',
    qualityMatches: 'Qualitätsspiele',
    moreMatches: 'Mehr Spiele verfügbar',
    
    // Sport Mode
    sportMode: 'Sportmodus',
    footballOnly: 'Fußball',
    tennisOnly: 'Tennis',
    autoMode: 'Auto',
    autoModeDesc: 'Fußball zuerst, dann Tennis',
    noQualityMatches: 'Derzeit keine hochwertigen Wettmöglichkeiten verfügbar',
    eliteMatch: 'Elite-Liga',
    professionalMatch: 'Professionelle Liga',
    highConfidence: 'Hohes Vertrauen',
    lowConfidence: 'Niedriges Vertrauen',
    tennisSoon: 'Tennis kommt bald!'
  }
};

export const languageNames = {
  pt: '🇵🇹 Português',
  en: '🇬🇧 English',
  es: '🇪🇸 Español',
  fr: '🇫🇷 Français',
  de: '🇩🇪 Deutsch'
};
